import { PriceSummary } from '~/graphql/mapper';
import { CarConfiMarketConfiguration } from '~/app/market-config';

export const getFilteredPriceParts = (
	priceSummary: PriceSummary | undefined,
	config: CarConfiMarketConfiguration,
): PriceSummary['parts'] => {
	// importCharge/destinationCharge priceparts remove the combined 'charges' price part to avoid double counting as charges already includes those
	const filterCombinedCharges =
		priceSummary?.parts?.some((a) => a.type === 'importCharge' || a.type === 'destinationCharge') ?? false;

	const priceParts = [...(priceSummary?.parts ?? [])]
		.sort(config.pricePartsOrderFunction)
		.filter(
			(p) =>
				(!filterCombinedCharges || p.type !== 'charges') &&
				p.price.value > 0 &&
				!config.uiPreferences?.prices?.hiddenPriceParts?.includes(p.type),
		);

	return priceParts || [];
};
